import { SET_ONBOARDING_STEP, SET_ONBOARDING_STATUS } from './onboardingTypes';

const initialState = {
  onboardingStep: -1,
  isOnboardingShown: true,
};

const onboardingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ONBOARDING_STEP:
      return { ...state, onboardingStep: action.payload };
    case SET_ONBOARDING_STATUS:
      return { ...state, isOnboardingShown: action.payload };
    default:
      return { ...state };
  }
};

export default onboardingReducer;
